

























import Vue from 'vue';
import DynamicFormFieldDefinitionResourceViewModel from '../../../services/viewModel/resource/DynamicFormDefinitionResourceViewModel';
import GetDynamicFormDefinitionRequestViewModel from '../../../services/viewModel/request/DynamicForm/GetDynamicFormDefinitionRequestViewModel';
import DynamicFormPostRequestViewModel from '../../../services/viewModel/resource/DynamicFormPostRequestViewModel';
import DynamicFormPayloadResourceViewModel from '../../../services/viewModel/resource/DynamicFormPayloadResourceViewModel';

export default Vue.extend({
  name: 'DynamicForm',
  props: {

  },
  data: () => ({
    formSummary: {},
    isLoading: true,
    isPostingForm: true,
    errorResponse: undefined as any,
    formDefinition: new DynamicFormFieldDefinitionResourceViewModel(),
    formPayload: new DynamicFormPayloadResourceViewModel(),
  }),
  computed: {
    appSystemKey(): string {
      return this.$route.query.appSystemKey as string;
    },
    id(): string {
      return this.$route.query.id as string;
    },
  },
  async mounted() {
    await this.loadFormDefinition();
  },
  methods: {
    async postForm() {
      this.isPostingForm = true;
      try {
        const req = new DynamicFormPostRequestViewModel().fromModel({
          appSystemKey: this.appSystemKey,
          form: this.formPayload,
          id: this.id,
        });
        this.$service.api.core.dynamicForm.postDynamicForm(req);
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isPostingForm = false;
    },
    async loadFormDefinition() {
      this.isLoading = true;
      try {
        const req = new GetDynamicFormDefinitionRequestViewModel();
        req.appSystemKey = this.appSystemKey;
        req.id = this.id;
        this.errorResponse = undefined;
        this.formDefinition = await this.$service.api.core.dynamicForm.getDynamicFormDefinition(req);
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isLoading = false;
    },
  },
});
